import React from 'react';
import Styles from './buttonStyle.module.scss';

const Button = (props: any) => {
  return (
    <button className={Styles.button} onClick={props.onClick} disabled={props.disabled || false}>
      {props.isLoading && (
        <div
          style={{
            width: '16px',
            height: '16px',
            border: '2px solid #999',
            borderTop: '2px solid #161617',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            marginRight: '8px',
          }}
        />
      )}
      <span>{props.label}</span>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </button>
  );
};
export default Button;
